module.exports = __webpack_public_path__ + "static/media/partner-icon.11bb8742.svg";